import {nameToUrl} from "../../navigation/nameToUrl";
import {transliterateString} from "../transliterateString";

export const ensureSlug = async (slug: string) => {
    return nameToUrl(await transliterateString(slug));
}
